module.exports = __webpack_public_path__ + "static/img/stock-grey.a7a94a8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/sidebar/stock-grey.svg
// module id = 622
// module chunks = 2